import * as actionTypes from '../actions/actionTypes';
import {haveSameFields} from "../../utils/utils";

const initialState = {
    // existing state
    user_modal: {
        isOpen: false,
        type: null, // TODO: use to change into edit mode.
        selectedUserId: null
    },
    misc_search_modal: {
        isOpen: false,
        // type: null, // TODO: use to change into edit mode.
        // selectedUserId: null
    },
    merge_selection_modal: {
        isOpen: false,
        selectedFrom: {id: null, name: null},
        selectedTo: {id: null, name: null}
    },
    merge_modal: {
        isOpen: false,
        selectedFrom: {id: null, name: null},
        selectedTo: {id: null, name: null},
        problems: []
    }
    // other state properties...
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        // Existing cases...
        case actionTypes.OPEN_USER_MODAL:
            return {
                ...state,
                user_modal: {
                    ...state.user_modal,
                    isOpen: true,
                },
            };
        case actionTypes.CLOSE_USER_MODAL:
            return {
                ...state,
                user_modal: {
                    ...state.user_modal,
                    isOpen: false,
                },
            };
        case actionTypes.SELECT_USER:
            return {
                ...state,
                user_modal: {
                    ...state.user_modal,
                    selectedUserId: action.userId
                }
            }
        case actionTypes.OPEN_MISC_SEARCH_MODAL:
            return {
                ...state,
                misc_search_modal: {
                    ...state.misc_search_modal,
                    isOpen: true,
                }
            }
        case actionTypes.CLOSE_MISC_SEARCH_MODAL:
            return {
                ...state,
                misc_search_modal: {
                    ...state.misc_search_modal,
                    isOpen: false,
                }
            }
        case actionTypes.OPEN_MERGE_SELECT_MODAL: {
            return {
                ...state,
                merge_selection_modal: {
                    isOpen: true,
                    selectedTo: action.to && haveSameFields(action.to, initialState.merge_selection_modal.selectedTo) ? action.to : initialState.merge_selection_modal.selectedTo,
                    selectedFrom: action.from && haveSameFields(action.from, initialState.merge_selection_modal.selectedFrom) ? action.from : initialState.merge_selection_modal.selectedFrom,
                }
            }
        }
        case actionTypes.CLOSE_MERGE_SELECT_MODAL: {
            return {
                ...state,
                merge_selection_modal: {
                    ...initialState.merge_selection_modal
                }
            }
        }
        case actionTypes.SUBMIT_MERGE_SELECT_MODAL: {
            return {
                ...state,
                merge_modal: {
                    isOpen: true,
                    selectedTo: action.to && haveSameFields(action.to, initialState.merge_selection_modal.selectedTo) ? action.to : initialState.merge_selection_modal.selectedTo,
                    selectedFrom: action.from && haveSameFields(action.from, initialState.merge_selection_modal.selectedFrom) ? action.from : initialState.merge_selection_modal.selectedFrom,
                    problems: []
                },
                merge_selection_modal: initialState.merge_selection_modal
            }
        }
        case actionTypes.CLOSE_MERGE_MODAL: {
            return {
                ...state,
                merge_modal: initialState.merge_modal
            }
        }
        case actionTypes.SET_MERGE_MODAL_PROBLEMS: {
            return {
                ...state,
                merge_modal: {
                    ...state.merge_modal,
                    problems: action.problems,
                }
            }
        }
        // Other cases...
        default:
            return state;
    }
};

export default reducer;
